// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"22c6f6e597aad301991cb8424ef18d113e6fbd7d"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/next-bee-website";globalThis["_sentryAssetPrefix"] = "https://static-cdn.mifengjiaoyu.com/next-bee-website";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://a74507ffaf97360efd9ad38cbd369b0c@csbase-sentry-aliyun-online.intsig.net/35",

  // 设置release版本以便正确关联sourcemap
  release:
    process.env.NEXT_PUBLIC_SENTRY_RELEASE ||
    `next-bee-website@${process.env.npm_package_version || "unknown"}`,

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      // 减少内容屏蔽，提高可读性
      maskAllText: false,
      maskAllInputs: false,
      // 只屏蔽包含敏感信息的元素
      block: [".sentry-block", "[data-sentry-block]"],
      mask: [".sentry-mask", "[data-sentry-mask]", 'input[type="password"]'],
      // 忽略某些元素
      ignore: [".sentry-ignore", "[data-sentry-ignore]"],
      // 网络配置，允许录制网络请求和资源
      networkDetailAllowUrls: [
        // 允许录制CDN资源
        process.env.NEXT_PUBLIC_CDN_URL || "",
        // 允许录制当前域名的资源
        window.location.origin,
      ].filter(Boolean),
      // 捕获网络请求体和响应体
      networkCaptureBodies: true,
      // 捕获网络请求头
      networkRequestHeaders: ["User-Agent", "Accept", "Content-Type"],
      networkResponseHeaders: ["Content-Type", "Content-Length"],
      // 使用更积极的资源捕获策略
      useCompression: false,
    }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // 环境变量
  environment: process.env.NODE_ENV,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
